export function useUsages() {
  const { $fetchAPI } = useNuxtApp();

  async function getUserTokenBalance(): Promise<number> {
    return await $fetchAPI<number>('/api/usages/balance');
  }

  return { getUserTokenBalance };
}
